import SettingsButton from "./SettingsButton";

export default SettingsButton;
export { SettingsButton };
